import { useEffect, useState, } from 'react';
import { isEmpty } from '../../Utils/string';
import Spinner from '../../Components/Spinner'
import LeafletNearestDrivers from '../../Components/LeafletNearestDrivers';

const OrderDriverTrace = () => {

    const [coordinateDriver, setCoordinateDriver] = useState<[{ latitude: number; longitude: number }]>([{ latitude: 0, longitude: 0 }]);
    const [mergedDestinations, setMergedDestinations] = useState<Array<[]>>([]);
    const [dataOrderRide, setDataOrderRide] = useState<any[]>([]);
    const [driverData, setDriverData] = useState<any | null>(null);

    useEffect(() => {
        document.addEventListener('message', (event: any) => {
            const receivedData = JSON.parse(event.data);
            if (receivedData.type === 'ORDERED_PAYLOAD') {
                setDriverData(receivedData?.payload?.drivers);
                setDataOrderRide(receivedData?.payload?.dataOrderRide);
            }
        });
    }, []);

    // Update coordinateDriver when tracking data changes
    useEffect(() => {
        if (driverData) {
            setCoordinateDriver([{
                latitude: driverData?.[0]?.latitude,
                longitude: driverData?.[0]?.longitude
            }]);
        }
    }, [driverData]);

    // Update mergedDestinations when dataOrderRide or coordinateDriver changes
    useEffect(() => {
        if (dataOrderRide?.[0]?.destination && coordinateDriver.length > 0) {
            setMergedDestinations([
                ...dataOrderRide?.[0]?.destination,
                ...coordinateDriver
            ]);
        }
    }, [dataOrderRide, coordinateDriver,]);

    // Cek jika semua data sudah siap sebelum render peta
    const isDataReady = (
        dataOrderRide?.[0]?.pickup_point &&
        mergedDestinations.length > 0
    );

    return (
        <>

            <>
                {/* {isEmpty(dataOrderRide) ? ( */}
                {isEmpty(driverData) ? (
                    <Spinner />
                ) : (
                    <>
                        {isDataReady ? (
                            <>
                                <LeafletNearestDrivers
                                    customer={dataOrderRide?.[0]?.pickup_point}
                                    drivers={mergedDestinations}
                                    zoom={14}
                                    isReverseGeocode={false}
                                    isShowHandleDriverClick={false}
                                    isPickupPoint={true}
                                    height="86vh"
                                />
                                {/* <div className="p-4 shadow-none rounded-none">
                                    <div className="grid grid-cols-12 gap-0 items-center">
                                        <div className="col-span-8">
                                            <p><strong>Invoice</strong></p>
                                            {dataOrderRide?.[0]?.invoice_no_ride || "N/A"}
                                        </div>
                                        <div className="col-span-4">
                                            <p><strong>Jarak</strong></p>
                                            {`${dataOrderRide?.[0]?.distance} KM` || "N/A"}
                                        </div>
                                        <div className="col-span-8">
                                            <p><strong>Pesan</strong></p>
                                            {dataOrderRide?.[0]?.message || ""}
                                        </div>
                                        <div className="col-span-4">
                                            <p><strong>Tarif</strong></p>
                                            {dataOrderRide?.[0]?.base_fare_negotiations
                                                ? convertToRupiah(dataOrderRide?.[0]?.base_fare_negotiations)
                                                : convertToRupiah(dataOrderRide?.[0]?.base_fare)}
                                        </div>
                                    </div>
                                </div> */}
                            </>
                        ) : (
                            <Spinner />
                        )}
                    </>
                )}
            </>
        </>
    );
}

export default OrderDriverTrace;
